import React from 'react';
import LoginForm from '../../components/auth/LoginForm';
import { RiBuildingLine, RiTeamLine, RiServerLine, RiFileTextLine, RiBarChartBoxLine } from 'react-icons/ri';
import { VERSION_LABEL } from '../../version';

const Login: React.FC = () => {
  return (
    <main className="min-h-screen flex flex-col md:flex-row bg-secondary-50" aria-label="หน้าเข้าสู่ระบบ">
      {/* ซ้าย - โลโก้และแบรนด์ - Executive Navy Theme */}
      <div className="w-full md:w-1/2 bg-gradient-to-br from-primary-800 via-primary-900 to-primary-950 flex flex-col justify-center items-start md:items-center p-8 md:p-12 text-white relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMtOS45NDEgMC0xOCA4LjA1OS0xOCAxOHM4LjA1OSAxOCAxOCAxOCAxOC04LjA1OSAxOC0xOC04LjA1OS0xOC0xOC0xOHptMCAzMmMtNy43MzIgMC0xNC02LjI2OC0xNC0xNHM2LjI2OC0xNCAxNC0xNCAxNCA2LjI2OCAxNCAxNC02LjI2OCAxNC0xNCAxNHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjAyIi8+PC9nPjwvc3ZnPg==')] opacity-30" />
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent-500/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-400/10 rounded-full blur-3xl" />

        <div className="w-full max-w-md relative z-10">
          <div className="text-center md:text-left">
            {/* Logo */}
            <div className="flex items-center justify-center md:justify-start mb-2">
              <div className="w-14 h-14 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20 shadow-lg">
                <RiBuildingLine className="w-8 h-8 text-white" />
              </div>
              <div className="ml-4">
                <h1 className="text-3xl font-bold tracking-tight">
                  ระบบจัดการ
                </h1>
                <div className="flex items-center gap-2 mt-1">
                  <div className="w-8 h-0.5 bg-gradient-to-r from-accent-400 to-accent-600 rounded-full" />
                  <span className="text-accent-400 text-sm font-medium">KRP</span>
                </div>
              </div>
            </div>

            <h2 className="mt-4 text-xl font-medium text-primary-100">
              ระบบจัดการข้อมูลการเช่าอุปกรณ์
            </h2>
            <p className="mt-4 text-primary-200/80 leading-relaxed">
              ปรับปรุงการดำเนินงานของบริษัทด้วยระบบจัดการข้อมูลการเช่าอุปกรณ์ที่ทันสมัย
              ตรวจสอบสถานะอุปกรณ์และการเช่าแบบเรียลไทม์และเพิ่มประสิทธิภาพกระบวนการทำงาน
            </p>

            {/* Feature Cards */}
            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="group bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 hover:bg-white/10 hover:border-accent-500/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent-400 to-accent-600 flex items-center justify-center mb-3 group-hover:shadow-lg group-hover:shadow-accent-500/20 transition-all">
                  <RiTeamLine className="w-5 h-5 text-white" />
                </div>
                <h3 className="font-semibold text-white">จัดการข้อมูลลูกค้า</h3>
                <p className="text-sm text-primary-200/70 mt-1">บันทึกข้อมูลและติดตามประวัติการเช่าของลูกค้า</p>
              </div>
              <div className="group bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 hover:bg-white/10 hover:border-accent-500/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent-400 to-accent-600 flex items-center justify-center mb-3 group-hover:shadow-lg group-hover:shadow-accent-500/20 transition-all">
                  <RiServerLine className="w-5 h-5 text-white" />
                </div>
                <h3 className="font-semibold text-white">จัดการอุปกรณ์</h3>
                <p className="text-sm text-primary-200/70 mt-1">เพิ่มประสิทธิภาพสินค้าคงคลังและลดการสูญหาย</p>
              </div>
              <div className="group bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 hover:bg-white/10 hover:border-accent-500/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent-400 to-accent-600 flex items-center justify-center mb-3 group-hover:shadow-lg group-hover:shadow-accent-500/20 transition-all">
                  <RiFileTextLine className="w-5 h-5 text-white" />
                </div>
                <h3 className="font-semibold text-white">จัดการสัญญา</h3>
                <p className="text-sm text-primary-200/70 mt-1">จัดการข้อมูลสัญญาเช่าอุปกรณ์อย่างมีประสิทธิภาพ</p>
              </div>
              <div className="group bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 hover:bg-white/10 hover:border-accent-500/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent-400 to-accent-600 flex items-center justify-center mb-3 group-hover:shadow-lg group-hover:shadow-accent-500/20 transition-all">
                  <RiBarChartBoxLine className="w-5 h-5 text-white" />
                </div>
                <h3 className="font-semibold text-white">สร้างรายงาน</h3>
                <p className="text-sm text-primary-200/70 mt-1">วิเคราะห์ข้อมูลและสร้างรายงานที่มีประโยชน์</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ขวา - แบบฟอร์มเข้าสู่ระบบ */}
      <div className="w-full md:w-1/2 flex justify-center items-center p-8 md:p-12 bg-gradient-to-b from-secondary-50 to-white">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-xl border border-secondary-100 p-8">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-secondary-900">เข้าสู่ระบบ</h2>
              <p className="mt-2 text-secondary-500">
                ยินดีต้อนรับ! กรุณากรอกข้อมูลประจำตัวของคุณ
              </p>
            </div>

            <LoginForm />
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-secondary-400">
              &copy; {new Date().getFullYear()} ระบบจัดการข้อมูลการเช่าอุปกรณ์ สงวนลิขสิทธิ์
            </p>
            <p className="mt-1 text-xs text-secondary-300" title={VERSION_LABEL}>{VERSION_LABEL}</p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;
